import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTranscriptionPanelWireframe from '../VeltTranscriptionPanelWireframe/VeltTranscriptionPanelWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltTranscriptionEmbedModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-embed-mode-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionEmbedModeWireframe.Panel = VeltTranscriptionPanelWireframe;
export default VeltTranscriptionEmbedModeWireframe;
